import $ from 'jquery';

const mobileSearchInit = () => {
    const $submitArea = $('.c-mobile-search .form-group-submit');
    const $submitInput = $('.c-mobile-search .form-group-submit input');
    const focusClass = 'has-focus';

    $submitArea.on('click', () => {
        $submitInput.click();
    });

    $submitInput.on('focus', function () {
        $(this).parent().addClass(focusClass);
    });

    $submitInput.on('focusout', function () {
        $(this).parent().removeClass(focusClass);
    });
};

// doc ready
$(() => {
    mobileSearchInit();
});
